import { useState } from 'react';
import { useSSO } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import LogoutIcon from '@mui/icons-material/Logout';
import AddIcon from '@mui/icons-material/Add';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import DashboardIcon from '@mui/icons-material/Dashboard';

const ResponsiveAppBar = () => {
  const { userData, logout } = useSSO();

  const navigate = useNavigate();

  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    handleCloseUserMenu();
    logout();
  };

  const handleCreate = () => {
    handleCloseUserMenu();
    navigate('/');
  };

  const handleMyProposals = () => {
    navigate('/my-proposals');
  };

  const handleDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        bgcolor: "#fff",
        color: "#000",
        zIndex: 999,
        boxShadow: 1,
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box
            sx={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
            }}
            onClick={() => window.location.assign('/')}
          >
            <img
              src="/logo192.png"
              alt="Company Logo"
              style={{ height: 40, marginRight: 12 }}
            />

            <Typography
              variant="h6"
              noWrap
              sx={{
                mr: 2,
                display: 'flex',
                flexGrow: { xs: 1, md: 0 },
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                textDecoration: 'none',
                color: '#1e293b',
              }}
            >
              PROPOSALGENERATOR
            </Typography>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex' } }}>
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar
                  sx={{
                    backgroundColor: '#e0f2fe',
                    color: '#0369a1',
                    fontWeight: 600,
                    fontSize: '0.875rem'
                  }}
                  alt="Remy Sharp"
                >
                  {userData?.userInitials}
                </Avatar>
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem onClick={handleCreate}>
                <ListItemIcon>
                  <AddIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Create Proposal</ListItemText>
              </MenuItem>

              {userData?.isSuperUser &&
                <MenuItem onClick={handleDashboard}>
                  <ListItemIcon>
                    <DashboardIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Dashboard</ListItemText>
                </MenuItem>
              }

              <MenuItem onClick={handleMyProposals}>
                <ListItemIcon>
                  <FormatListBulletedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>My Proposals</ListItemText>
              </MenuItem>

              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Logout</ListItemText>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
